import { useNavigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { useFeatureIsOn } from "@/app/featureFlags";
import { Switcher } from "@/components/Switcher/Switcher";
import { SwitcherButton } from "@/components/Switcher/SwitcherButton";
import {
  rudderAnalytics,
  HotelTrackingEvents,
  FlightTrackingEvents,
  TripTrackingEvents,
} from "@/lib/rudderstack";
import type { SearchScope } from "@/types/types";

type CategorySwitcherProps = {
  current: SearchScope;
};

const eventMap = {
  flights: FlightTrackingEvents.USER_SEARCHED_FOR_ORDERS,
  hotels: HotelTrackingEvents.USER_SEARCHED_FOR_ORDERS,
  trips: TripTrackingEvents.USER_SEARCHED_FOR_ORDERS,
} as const;

export const CategorySwitcher = ({ current }: CategorySwitcherProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <Switcher
      value={current}
      onChange={(newCategory) => {
        if (eventMap[newCategory]) {
          rudderAnalytics.track(eventMap[newCategory]);
        }

        navigate({
          to: "/bookings",
          search: {
            category: newCategory,
          },
          replace: true,
        });
      }}
    >
      <SwitcherButton
        value="flights"
        label={intl.formatMessage({
          defaultMessage: "Flights",
          description: "flights.title",
        })}
      />
      <SwitcherButton
        value="hotels"
        label={intl.formatMessage({
          defaultMessage: "Hotels",
          description: "hotels.title",
        })}
      />
      {useFeatureIsOn("trips-flow") && (
        <SwitcherButton
          value="trips"
          label={intl.formatMessage({
            defaultMessage: "Trips",
            description: "trips.title",
          })}
        />
      )}
    </Switcher>
  );
};
